import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Admin from '@/pages/Admin'
import Member from '@/pages/Member'
import MemberEditNew from '@/pages/MemberEditNew'
import SmsService from '@/pages/SmsService'
import Docs from '@/pages/Docs'
import User from '@/pages/User'
import UserEditNew from '@/pages/UserEditNew'
import Settings from '@/pages/Settings'
import Security from '@/pages/Security'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: __dirname,
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/login/:status',
      name: 'loginstatus',
      component: Login,
      meta: {title: 'Login' + store.state.titlepostfix}
    },
    {
      path: '/login/:status/:regnummer/:user_id',
      name: 'loginregnummer',
      component: Login,
      meta: {title: 'Login' + store.state.titlepostfix}
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {title: 'Login' + store.state.titlepostfix}
    },
    {
      path: '/',
      name: 'admin',
      component: Admin,
      meta: {title: 'Admin' + store.state.titlepostfix},
      children: [
        {
          path: 'member',
          component: Member,
          meta: {title: 'Mitglieder' + store.state.titlepostfix}
        },
        {
          path: 'editMember/:member_id',
          name: 'editMember',
          component: MemberEditNew,
          meta: {title: 'Mitglied editieren' + store.state.titlepostfix},
          props: true
        },
        {
          path: 'newMember/',
          name: 'newMember',
          component: MemberEditNew,
          meta: {title: 'Mitglied hinzufügen' + store.state.titlepostfix},
          props: true
        },
        {
          path: 'smsservice/:page_sms',
          name: 'smsservice',
          component: SmsService,
          meta: {title: 'SMS - Service' + store.state.titlepostfix}
        },
        {
          path: 'smsservice/',
          component: SmsService,
          meta: {title: 'SMS - Service' + store.state.titlepostfix}
        },
        {
          path: 'docs',
          component: Docs,
          meta: {title: 'Dokumente' + store.state.titlepostfix}
        },
        {
          path: 'user',
          component: User,
          meta: {title: 'Benutzer' + store.state.titlepostfix}
        },
        {
          path: 'editUser/:user_id',
          name: 'editUser',
          component: UserEditNew,
          meta: {title: 'Benutzer editieren' + store.state.titlepostfix},
          props: true
        },
        {
          path: 'newUser',
          name: 'newUser',
          component: UserEditNew,
          meta: {title: 'Benutzer hinzufügen' + store.state.titlepostfix},
          props: true
        },
        {
          path: 'settings',
          component: Settings,
          meta: {title: 'Einstellungen' + store.state.titlepostfix}
        },
        {
          path: 'security',
          component: Security,
          meta: {title: 'Sicherheit' + store.state.titlepostfix}
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router






// WEBPACK FOOTER //
// ./src/router/index.js